import React, { FormEvent, useCallback, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'
import AdminUserContext from '../../context/AdminUser'
import useApi from '../../hooks/useApi'
import { SubmitButton } from '../../Korbantech/components/Buttons/SubmitButton'
import { PasswordInput } from '../../Korbantech/components/Inputs/PasswordInput'
import { TextInput } from '../../Korbantech/components/Inputs/TextInput'
import { Label } from '../../Korbantech/components/Label'
import { BRAND_LOGO } from '../../utils/constants'

const Login = ( ) => {

    const api = useApi( )
    const navigate = useNavigate()

    const { state: user, setState: setUser } = useContext( AdminUserContext )
    const handleSubmit = useCallback( async ( e:FormEvent<HTMLFormElement> ) => {
        e.preventDefault()
        e.currentTarget.checkValidity()

        const data = new FormData( e.currentTarget )

        await api.post<string>( 'admin/auth/login', data ).then( async res => {
            const token = res.data
            const headers = {
              'Authorization': `Bearer ${token}`
            }
            await api.get( 'admin/me', { headers } ).then( res => {
                setUser( {
                    ...res.data,
                    access_token: token
                } )
            }).catch( console.log )
        } ).catch( console.log )
    }, [ api, setUser ] )

    useEffect( () => {
        if( user ) navigate( '/admin' )
    }, [ user, navigate ] )

    return(
        <div className="bg-gray-200 h-screen w-screen flex items-center justify-center">
            <form className="max-w-xs w-4/5 bg-white p-2 pt-3 border border-gray-500" onSubmit={ handleSubmit }>
                <div className="w-full flex flex-col items-center justify-center">

                    <img
                        className='-mb-3'
                        width={'120'}
                        height="auto"
                        src={ BRAND_LOGO }
                        alt=""
                    />
                    <div className='font-semibold text-gray-500'>Área administrativa</div>
                 
       
                </div>
                <div className="mt-2 p-4 grid grid-cols-1 rounded-lg">
                    <Label>
                        Email
                        <TextInput name="email" required />
                    </Label>
                    <Label >
                        Senha
                        <PasswordInput name="password" required/>
                    </Label>
                    <div className="center">
                        <SubmitButton className="bg-brand-button text-brand-button-text mt-2" value="Login"/>
                    </div>
                </div>
            </form>
        </div>
    )
}


export default Login

